import { render, staticRenderFns } from "./VerTramiteView.vue?vue&type=template&id=012655f5"
import script from "./VerTramiteView.vue?vue&type=script&lang=ts"
export * from "./VerTramiteView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports